import React from "react";
import {connect} from "react-redux";
import {updatePage} from "../../actions/page";
import {DEFAULT_PER_PAGE} from "../../config";
import {displayErrors} from "../../libs/utils";
import {
    deleteCompanyWebhook,
    loadCompanyWebhooks
} from "../../actions/account";
import AccessItem from "../permissions/AccessItem";
import {Button, Col, message, Popconfirm, Row, Space, Table, Tag, Tooltip} from "antd";
import AccessGate from "../permissions/AccessGate";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import UndoOutlined from "@ant-design/icons/lib/icons/UndoOutlined";
import EditOutlined from "@ant-design/icons/lib/icons/EditOutlined";
import {hasPermission} from "../permissions/PermissionUtils";
import {DeleteOutlined, UnorderedListOutlined} from "@ant-design/icons";
import WebhookModal from "./WebhookModal";
import WebhookSecret from "./WebhookSecret";
import WebhooksLogModal from "./WebhooksLogModal";

class Webhooks extends React.Component {
    state = {
        pagination: { current: 1, pageSize: DEFAULT_PER_PAGE, total: 0, showSizeChanger: true },
        data: [],
        loadingData: true,
        showModal: false,
        activeWebhook: null,
        showLogsModal: false,
    };

    componentDidMount() {
        this.props.updatePage('Webhooks');
        this.loadWebhooks();
    }

    loadWebhooks(page = null, per_page = null) {
        if(page === null) {
            page = this.state.pagination.current;
        }

        if(per_page === null) {
            per_page = this.state.pagination.pageSize;
        }

        this.setState({ loadingData: true });

        this.props.loadCompanyWebhooks(this.props.companyGuid, page, per_page, (res) => {
            this.setState({ data: res.data.data, loadingData: false, pagination: { current: res.data.page, pageSize: res.data.per_page, total: res.data.total, showSizeChanger: true }});
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loadingData: false });
                displayErrors(err.response.data);
            }
        });
    }

    deleteWebhook(guid) {
        this.props.deleteCompanyWebhook(this.props.companyGuid, guid, () => {
            message.success('Webhook successfully deleted!');
            this.loadWebhooks();

        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loadingData: false });
                displayErrors(err.response.data);
            }
        });
    }

    changePage(data) {
        this.loadWebhooks(data.current, data.pageSize);
    }

    render() {
        const columns = [
            {title: 'Name', dataIndex: 'name'},
            {title: 'URL', dataIndex: 'url', render: (item) => <code>{item}</code>},
            {title: 'Secret', dataIndex: 'secret', render: (item, record) => <WebhookSecret webhookId={record.guid} secret={item} reload={() => this.loadWebhooks()} />},
            {title: 'Delivered (24h)', align: 'center', width: '140px', dataIndex: 'delivered'},
            {title: 'Failed (24h)', align: 'center', width: '120px', dataIndex: 'failed'},
            {title: 'Events', dataIndex: 'events', render: (item) => item.map(value => <Tag key={value}>{value}</Tag>)},
        ];

        if (hasPermission(this.props.company.permissions, ['can_delete_webhooks'])) {
            columns.push({
                align: 'right', render: (item, record) => {
                    return <Space>
                        <Button size='small' icon={<EditOutlined/>} onClick={() => this.setState({ showModal: true, activeWebhook: record.guid })}>Edit</Button>
                        <Button size='small' icon={<UnorderedListOutlined />} onClick={() => this.setState({ showLogsModal: true, activeWebhook: record.guid })}>Logs</Button>
                        <Popconfirm
                            onConfirm={() => this.deleteWebhook(record.guid)}
                            placement='topRight'
                            title="Are you sure you want to delete it?"
                            okText="Delete"
                            okType='danger'
                            cancelText="Cancel">
                            <Button size='small' danger icon={<DeleteOutlined/>}/>
                        </Popconfirm>
                    </Space>;
                }
            });

            return (
                <AccessGate scopes={['can_view_api_keys']}>
                    <Row justify='space-between' style={{marginBottom: '10px'}}>
                        <Col>
                            <AccessItem scopes={['can_create_api_keys']}>
                                <Button type='primary' icon={<PlusOutlined/>}
                                        onClick={() => this.setState({ showModal: true})}>Add Webhook</Button>
                            </AccessItem>
                        </Col>
                        <Col><Tooltip title='Reload' placement='left'>
                            <Button onClick={() => this.loadWebhooks()} type='text' icon={<UndoOutlined/>}/></Tooltip>
                        </Col>
                    </Row>
                    <div style={{overflowX: 'auto'}}>
                        <Table
                            columns={columns}
                            rowKey={(item) => item.guid}
                            dataSource={this.state.data}
                            loading={this.state.loadingData}
                            pagination={this.state.pagination}
                            onChange={(e) => this.changePage(e)}
                        />
                    </div>

                    <WebhookModal
                        showModal={this.state.showModal}
                        webhookId={this.state.activeWebhook}
                        companyGuid={this.props.companyGuid}
                        close={(reload) => {
                            this.setState({ showModal: false, activeWebhook: null })

                            if (reload) {
                                this.loadWebhooks();
                            }
                        }} />

                    <WebhooksLogModal
                        showModal={this.state.showLogsModal}
                        webhookId={this.state.activeWebhook}
                        companyGuid={this.props.companyGuid}
                        close={() => this.setState({ showLogsModal: false })} />
                </AccessGate>
            );
        }
    }
}

const mapStateToProps = state => ({
    company: state.auth.user.user.company
});

export default connect(mapStateToProps, { updatePage, deleteCompanyWebhook, loadCompanyWebhooks })(Webhooks);